import { useService } from "@services/ServiceContext";
import { ServiceKey } from "@journeyteam/dependency-injection";
import { UserPrincipal } from "@/models/User";
import useSwr from "swr";
import * as React from "react";
export class UserService {
	public static serviceKey = ServiceKey.create<UserService>("UserService", UserService);

	async getCurrentUserPrincipal() {
		const response = await fetch("/.auth/me");
		const json = await response.json();
		return json as UserPrincipal;
	}
}

export function useUserService() {
	return useService(UserService.serviceKey);
}

export function useCurrentUserPrincipal() {
	const us = useUserService();
	const upResults = useSwr("user-principal", () => us.getCurrentUserPrincipal());
	return React.useMemo(() => {
		return {
			...upResults,
			principal: upResults.data,
		};
	}, [upResults]);
}

export function useUserHasRoles(roles: string[], any?: boolean) {
	const { data: user } = useCurrentUserPrincipal();

	const hasRoles = React.useMemo(() => {
		const userRoles: string[] = user?.clientPrincipal?.userRoles ?? [];
		return any
			? roles.some((i) => userRoles.includes(i))
			: roles.every((i) => userRoles.includes(i));
	}, [roles, any, user]);
	return hasRoles;
}
